import angular from 'angular';
import ApplyCreditNoteModalComponent from './apply.credit.note.modal.component';
export default angular.module('invision.customercare.applyCreditNoteModal', []).component('applyCreditNoteModal', ApplyCreditNoteModalComponent).name;